var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"main","role":"main"}},[_c('cover'),_c('introduction'),_c('major-scenarios'),_c('solutions'),_c('videos'),_c('roadmap'),_c('ecosystem'),_c('download'),_c('contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }